export default __webpack_public_path__ + "static/media/example_2.b5fa3fc0.png";